var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6 12C9.6125 12 8 13.6288 8 15.6364C8 17.6439 9.6125 19.2727 11.6 19.2727H52.4C54.3875 19.2727 56 17.6439 56 15.6364C56 13.6288 54.3875 12 52.4 12H11.6ZM11.6 28.3636C9.6125 28.3636 8 29.9924 8 32C8 34.0076 9.6125 35.6364 11.6 35.6364H52.4C54.3875 35.6364 56 34.0076 56 32C56 29.9924 54.3875 28.3636 52.4 28.3636H11.6ZM11.6 44.7273C9.6125 44.7273 8 46.3561 8 48.3636C8 50.3712 9.6125 52 11.6 52H52.4C54.3875 52 56 50.3712 56 48.3636C56 46.3561 54.3875 44.7273 52.4 44.7273H11.6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.57bd01e0.svg";
export { ForwardRef as ReactComponent };